<!-- @format -->

<template>
    <component
        :is="config.card"
        ref="hotelCard"
        :class="config.cardClasses && config.cardClasses"
        v-bind="propsToBind(hotel)" />
</template>

<script>
export default {
    name: 'MapPopupHotelCard',
    props: {
        mapsApi: {
            type: Object,
            required: true,
        },
        map: {
            type: Object,
            required: true,
        },
        config: {
            type: Object,
            required: true,
        },
        hotel: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            popupInstance: null,
            popUpTop: 0,
        };
    },
    computed: {
        hasCampaign() {
            return this.hotel.campaign && this.hotel.campaign.type;
        },
    },
    watch: {
        hotel: {
            handler: function () {
                if (this.popupInstance) {
                    this.popupInstance.setLngLat([this.hotel.longitude, this.hotel.latitude]);

                    const popupEl = this.popupInstance.getElement();
                    if (this.hasCampaign) {
                        popupEl.classList.add('gst-map-hotel-popup--campaign');
                    } else {
                        popupEl.classList.remove('gst-map-hotel-popup--campaign');
                    }

                    this.sendPopupBounds();
                }
            },
            deep: true,
        },
    },
    methods: {
        propsToBind(item) {
            return this.config.propsToBind ? this.config.propsToBind(item) : item;
        },
        sendPopupBounds() {
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.hotelCard) {
                        this.popUpTop = this.$refs.hotelCard.$el.getBoundingClientRect().top;
                        this.$emit('open', this.$refs.hotelCard?.$el?.getBoundingClientRect());
                    }
                }, 10);
            });
        },
    },
    mounted() {
        const markerHeight = 40;
        const markerRadius = 10;
        const linearOffset = 25;
        const popupOffsets = {
            top: [0, 0],
            'top-left': [0, 0],
            'top-right': [0, 0],
            bottom: [0, -markerHeight],
            'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
            'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
            left: [markerRadius, (markerHeight - markerRadius) * -1],
            right: [-markerRadius, (markerHeight - markerRadius) * -1],
        };
        this.popupInstance = new this.mapsApi.Popup({
            offset: popupOffsets,
            maxWidth: '420px',
            className: `gst-map-hotel-popup ${this.hasCampaign ? 'gst-map-hotel-popup--campaign' : ''}`,
        })
            .setLngLat([this.hotel.longitude, this.hotel.latitude])
            .setDOMContent(this.$refs.hotelCard.$el)
            .addTo(this.map)
            .once('close', () => {
                this.$emit('closed');
            });

        this.sendPopupBounds();
    },
    beforeDestroy() {
        if (this.popupInstance) {
            this.popupInstance.remove();
        }
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-map-hotel-popup {
    min-width: 400px;
    z-index: $z-index-map-hotel-popup;

    .gst-loyalty-info-chip__section--minimum,
    .gst-loyalty-info-chip__section--maximum {
        p {
            margin-top: theme-spacing(n1);
        }
    }

    .mapboxgl-popup-tip {
        display: none;
    }

    .mapboxgl-popup-content {
        padding: 0;
        border-radius: border-radius('m');

        .gst-add-hotel-reservation-hotel-list-card__room {
            padding-right: 44px;
        }
    }

    &.gst-map-hotel-popup--campaign .mapboxgl-popup-close-button {
        top: 20px;
    }

    .mapboxgl-popup-close-button {
        top: 0;
        right: 0;
        height: 44px;
        width: 44px;
        color: theme-color('tertiary');
        font-size: font-size('xxxl');
        font-weight: bold;

        &:hover {
            background: none;
        }
    }
}

@include mobile-only {
    .gst-map-hotel-popup {
        position: absolute;
        top: auto;
        left: 10px;
        bottom: 10px;
        width: calc(100% - 20px);
        max-width: 100% !important;
        min-width: auto;
        transform: none !important;

        .mapboxgl-popup-content {
            width: 100%;
        }
    }
}
</style>
